// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ppt-cart-dd-items {
  display: table;
  list-style: none;
  padding: 0px;
  background: white;
  border: 1px solid rgba(88, 89, 91, 1);
  border-top: 10px solid rgba(0, 126, 167, 1);
  z-index: 1;
  width: 400px;
  padding: 10px;
  position: fixed;
  top: 35px;
  right: 48px;
}
.slides-header {
  display: flex;
  border-bottom: 1px solid rgba(88, 89, 91, 1);
}
.clear-all {
  margin-left: auto;
  color: rgba(66, 133, 244, 1);
  cursor: pointer;
}
.clear-all:hover {
  color: rgba(0, 126, 167, 1);
}
.slide-list {
}
.slides-container {
  padding-left: 2px;
  padding-right: 2px;
  max-height: 605px;
}
.ppt-btn-container {
  display: flex;
}
.ppt-cleanup-warning {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  margin: 0 0 12px;
  padding: 8px;
  border: 1px solid #d98b00;
  color: #6b4300;
  font-size: 12px;
}
.ppt-cleanup-warning button {
  flex-shrink: 0;
  border: 0;
  background: transparent;
  color: rgba(0, 126, 167, 1);
  cursor: pointer;
  font: inherit;
  font-weight: 700;
}
.ppt-cleanup-warning button:disabled {
  cursor: wait;
  opacity: 0.65;
}
.ppt-download-button {
  cursor: pointer;
  margin-bottom: 14px;
  background-color: rgba(0, 126, 167, 1);
  border-radius: 2px;
  color: white;
  display: inline-block;
  padding: 4px;
  margin-left: auto;
  margin-right: auto;
}

.slide-item {
  display: flex;
}
.cart-item {
  padding: 0px;
}
.ppt-cart {
  cursor: pointer;
  align-items: center;
  width: 19px;
  display: flex;
}
.ppt-cart-icon-wrap {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ppt-cart-activity {
  position: absolute;
  top: -6px;
  left: 6px;
  z-index: 1;
  pointer-events: none;
}

.power-point-icon-selected:hover {
  fill: white;
}
.ppt-cart-selected {
  cursor: pointer;
  align-items: center;
  width: 100%;
  height: 100%;
  display: flex;
  background: rgba(0, 126, 167, 1);
  justify-content: center;
}
.ppt-cart-parent {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 5px;
  width: 28px;
  height: 30px;
}
.ppt-cart-badge {
  position: absolute;
  cursor: pointer;
  right: 50px;
  bottom: 27px;
  background: rgba(0, 126, 167, 1);
  color: white;
  font-size: 10px;
  font-weight: 700;
  white-space: nowrap;
  display: inline-block;
  padding-top: 0px;
  padding-left: 4px;
  padding-right: 4px;
  text-align: center;
  border-radius: 0.25rem;
}

.slide-title {
  font-size: 12pt;
  font-style: italic;
  cursor: grab;
  touch-action: none;
}
.slide-copy {
  flex: 1;
  min-width: 0;
}
.slide-status {
  display: flex;
  align-items: center;
  gap: 5px;
  color: rgba(88, 89, 91, 1);
  font-size: 10px;
  font-style: normal;
}
.slide-status-failed {
  color: #b42318;
}
.slide-status-complete {
  color: #287a45;
}
.slide-status-spinner {
  width: 10px;
  height: 10px;
  border: 1px solid rgba(88, 89, 91, 0.3);
  border-top-color: rgba(0, 126, 167, 1);
  border-radius: 50%;
  animation: ppt-spin 0.8s linear infinite;
}
.slide-item:hover {
  color: rgba(0, 126, 167, 1);
}

.slide-delete-icon {
  margin-left: 10px;
  cursor: pointer;
  margin-top: -2px;
}

.download-ppt-icon {
  margin-right: 6px;
  margin-bottom: 4px;
}
.download-ppt-icon:hover {
  fill: white;
}

.slide-num {
  margin-right: 8px;
}

.ppt-download-button-disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.ppt-spinner {
  display: inline-block;
  width: 14px;
  height: 14px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: ppt-spin 0.8s ease-in-out infinite;
  margin-right: 8px;
  vertical-align: middle;
}

@keyframes ppt-spin {
  to {
    transform: rotate(360deg);
  }
}

/* AI Summary Option */
.ppt-ai-summary-option {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 12px;
  padding: 0 4px;
}

.ppt-ai-summary-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  font-size: 13px;
  color: rgba(88, 89, 91, 1);
  user-select: none;
}

.ppt-ai-summary-label:hover {
  color: rgba(0, 126, 167, 1);
}

.ppt-ai-summary-checkbox {
  margin-right: 6px;
  cursor: pointer;
  accent-color: rgba(0, 126, 167, 1);
}

.ppt-ai-summary-checkbox:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.ppt-ai-summary-icon {
  margin-right: 4px;
  flex-shrink: 0;
}

.ppt-ai-summary-label span {
  white-space: nowrap;
}

.ppt-ai-summary-disclaimer {
  margin-top: 4px;
  font-size: 11px;
  font-style: italic;
  color: rgba(136, 137, 139, 1);
  text-align: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/pptCart/style.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,qCAAqC;EACrC,2CAA2C;EAC3C,UAAU;EACV,YAAY;EACZ,aAAa;EACb,eAAe;EACf,SAAS;EACT,WAAW;AACb;AACA;EACE,aAAa;EACb,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;AACA;AACA;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;AACA;EACE,cAAc;EACd,SAAS;EACT,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;AACf;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;AACb;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;EACvC,sCAAsC;EACtC,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,kBAAkB;EAClB,uBAAuB;EACvB,6CAA6C;EAC7C,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,kBAAkB;AACpB","sourcesContent":[".ppt-cart-dd-items {\n  display: table;\n  list-style: none;\n  padding: 0px;\n  background: white;\n  border: 1px solid rgba(88, 89, 91, 1);\n  border-top: 10px solid rgba(0, 126, 167, 1);\n  z-index: 1;\n  width: 400px;\n  padding: 10px;\n  position: fixed;\n  top: 35px;\n  right: 48px;\n}\n.slides-header {\n  display: flex;\n  border-bottom: 1px solid rgba(88, 89, 91, 1);\n}\n.clear-all {\n  margin-left: auto;\n  color: rgba(66, 133, 244, 1);\n  cursor: pointer;\n}\n.clear-all:hover {\n  color: rgba(0, 126, 167, 1);\n}\n.slide-list {\n}\n.slides-container {\n  padding-left: 2px;\n  padding-right: 2px;\n  max-height: 605px;\n}\n.ppt-btn-container {\n  display: flex;\n}\n.ppt-cleanup-warning {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  margin: 0 0 12px;\n  padding: 8px;\n  border: 1px solid #d98b00;\n  color: #6b4300;\n  font-size: 12px;\n}\n.ppt-cleanup-warning button {\n  flex-shrink: 0;\n  border: 0;\n  background: transparent;\n  color: rgba(0, 126, 167, 1);\n  cursor: pointer;\n  font: inherit;\n  font-weight: 700;\n}\n.ppt-cleanup-warning button:disabled {\n  cursor: wait;\n  opacity: 0.65;\n}\n.ppt-download-button {\n  cursor: pointer;\n  margin-bottom: 14px;\n  background-color: rgba(0, 126, 167, 1);\n  border-radius: 2px;\n  color: white;\n  display: inline-block;\n  padding: 4px;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.slide-item {\n  display: flex;\n}\n.cart-item {\n  padding: 0px;\n}\n.ppt-cart {\n  cursor: pointer;\n  align-items: center;\n  width: 19px;\n  display: flex;\n}\n.ppt-cart-icon-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.ppt-cart-activity {\n  position: absolute;\n  top: -6px;\n  left: 6px;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.power-point-icon-selected:hover {\n  fill: white;\n}\n.ppt-cart-selected {\n  cursor: pointer;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  background: rgba(0, 126, 167, 1);\n  justify-content: center;\n}\n.ppt-cart-parent {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-right: 5px;\n  width: 28px;\n  height: 30px;\n}\n.ppt-cart-badge {\n  position: absolute;\n  cursor: pointer;\n  right: 50px;\n  bottom: 27px;\n  background: rgba(0, 126, 167, 1);\n  color: white;\n  font-size: 10px;\n  font-weight: 700;\n  white-space: nowrap;\n  display: inline-block;\n  padding-top: 0px;\n  padding-left: 4px;\n  padding-right: 4px;\n  text-align: center;\n  border-radius: 0.25rem;\n}\n\n.slide-title {\n  font-size: 12pt;\n  font-style: italic;\n  cursor: grab;\n  touch-action: none;\n}\n.slide-copy {\n  flex: 1;\n  min-width: 0;\n}\n.slide-status {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n  color: rgba(88, 89, 91, 1);\n  font-size: 10px;\n  font-style: normal;\n}\n.slide-status-failed {\n  color: #b42318;\n}\n.slide-status-complete {\n  color: #287a45;\n}\n.slide-status-spinner {\n  width: 10px;\n  height: 10px;\n  border: 1px solid rgba(88, 89, 91, 0.3);\n  border-top-color: rgba(0, 126, 167, 1);\n  border-radius: 50%;\n  animation: ppt-spin 0.8s linear infinite;\n}\n.slide-item:hover {\n  color: rgba(0, 126, 167, 1);\n}\n\n.slide-delete-icon {\n  margin-left: 10px;\n  cursor: pointer;\n  margin-top: -2px;\n}\n\n.download-ppt-icon {\n  margin-right: 6px;\n  margin-bottom: 4px;\n}\n.download-ppt-icon:hover {\n  fill: white;\n}\n\n.slide-num {\n  margin-right: 8px;\n}\n\n.ppt-download-button-disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n}\n\n.ppt-spinner {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 50%;\n  border-top-color: white;\n  animation: ppt-spin 0.8s ease-in-out infinite;\n  margin-right: 8px;\n  vertical-align: middle;\n}\n\n@keyframes ppt-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* AI Summary Option */\n.ppt-ai-summary-option {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-bottom: 12px;\n  padding: 0 4px;\n}\n\n.ppt-ai-summary-label {\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-size: 13px;\n  color: rgba(88, 89, 91, 1);\n  user-select: none;\n}\n\n.ppt-ai-summary-label:hover {\n  color: rgba(0, 126, 167, 1);\n}\n\n.ppt-ai-summary-checkbox {\n  margin-right: 6px;\n  cursor: pointer;\n  accent-color: rgba(0, 126, 167, 1);\n}\n\n.ppt-ai-summary-checkbox:disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.ppt-ai-summary-icon {\n  margin-right: 4px;\n  flex-shrink: 0;\n}\n\n.ppt-ai-summary-label span {\n  white-space: nowrap;\n}\n\n.ppt-ai-summary-disclaimer {\n  margin-top: 4px;\n  font-size: 11px;\n  font-style: italic;\n  color: rgba(136, 137, 139, 1);\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
